import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avmLink',
    standalone: true,
})
export class AvmLinkPipe implements PipeTransform {
    /**
     * Formate un lien.
     * @param linkRepresentation : Représentation JSON du lien
     * @param part : Représente la partie du lien à afficher.
     */
    transform(linkRepresentation: string, part: 'Url' | 'DisplayName'): string {
        var link = JSON.parse(linkRepresentation);

        if (!link) {
            return '';
        } else {
            if (part === 'Url') {
                return link.url;
            } else if (part === 'DisplayName') {
                return link.displayName;
            } else {
                return 'NotImplemented';
            }
        }
    }
}
